import { Trans } from "@lingui/react/macro";
import ArrowLeftIcon from "@medoma/components/icons/ArrowLeftIcon";
import { Link } from "@medoma/components/Link/Link";

export const GoBackLink = () => {
  return (
    <Link to=".." size="base">
      <ArrowLeftIcon />
      <Trans>Tillbaka</Trans>
    </Link>
  );
};
